// Утилиты для работы с историей поиска
export interface SearchHistoryItem {
  query: string;
  timestamp: number;
  resultCount: number;
}

const SEARCH_HISTORY_KEY = 'global_search_history';
/** Последние N запросов в подсказках глобального поиска */
const MAX_HISTORY_ITEMS = 5;

// Получить историю поиска
export const getSearchHistory = (): SearchHistoryItem[] => {
  try {
    const history = localStorage.getItem(SEARCH_HISTORY_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    console.error('Error loading search history:', error);
    return [];
  }
};

// Сохранить историю поиска
export const saveSearchHistory = (history: SearchHistoryItem[]): void => {
  try {
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Error saving search history:', error);
  }
};

// Добавить запрос в историю
export const addToSearchHistory = (query: string, resultCount: number): void => {
  if (!query.trim()) return;
  
  const history = getSearchHistory();
  const now = Date.now();
  
  // Удаляем дубликаты
  const filteredHistory = history.filter(item => item.query !== query);
  
  // Добавляем новый запрос в начало
  const newItem: SearchHistoryItem = {
    query: query.trim(),
    timestamp: now,
    resultCount
  };
  
  const updatedHistory = [newItem, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);
  saveSearchHistory(updatedHistory);
};

// Очистить историю поиска
export const clearSearchHistory = (): void => {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  } catch (error) {
    console.error('Error clearing search history:', error);
  }
};

// Получить популярные запросы (часто используемые)
export const getPopularQueries = (): string[] => {
  const history = getSearchHistory();
  const queryCounts: Record<string, number> = {};
  
  history.forEach(item => {
    queryCounts[item.query] = (queryCounts[item.query] || 0) + 1;
  });
  
  return Object.entries(queryCounts)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 5)
    .map(([query]) => query);
};
